let protection = [
  {
    title: '第1条（規約の適用範囲）',
    msg: 'この利用規約(以下「本規約」)は、KAITEKITV TECH  Co., Ltd（以下「弊社」）の運営するKaiteki TVサービス（以下「本サービス」）の利用者（以下「利用者」）が、本サービス利用時に順守すべき事項となります。'
  },
  {
    title: '第2条（個人情報の収集）',
    msg: '弊社業務遂行上必要となる、氏名や連絡先、居住国など最小限の個人情報を収集いたします。'
  },
  {
    title: '第3条（個人情報の利用及び提供）',
    msg: `取得した個人情報は、利用目的の範囲内で、業務の遂行上必要な限りにおいて利用します。<br/>
    万が一、利用目的の範囲を超えて利用する場合等は、事前に利用者に同意を得て行います。<br/>
    法令の定める場合等を除き、利用者の許可なく第三者に情報を提供いたしません。`
  },
  {
    title: '第4条（個人情報の利用目的）',
    msg: `①会社法に基づく権利の行使・義務の履行のため<br/>
    ②本人確認のため<br/>
    ③弊社サービス、または事業等に関する案内、及びそれらの変更・停止のため<br/>
    ④弊社が広報活動を行う上で必要となるデータなどを収集するため<br/>
    ⑤利用者との業務上の連絡のため<br/>
    ⑥利用者との契約の履行のため<br/>
    ⑦その他、弊社業務を適切かつ円滑に履行するため`
  },
  {
    title: '第5条（個人情報の管理）',
    msg: '取得した個人情報等をできるだけ正確かつ最新の内容に保つように努め、不要になった際は、当該個人情報等を含むデータを遅滞なく消去するよう努めます。また、弊社は個人データの漏洩、減失または毀損等の防止のために、個人データの取得・利用・保管等において適切な安全管理措置を講じます。'
  },
  {
    title: '第6条（責任及び注意義務について）',
    msg: `利用者は自己の責任に基づき本サービスを利用するものとします。<br/>
    何らかの原因により、弊社に対し損害賠償の請求などが起こった場合の損害、責任については、当該者以外の利用者については、一切を免責するものとします。`
  },
  {
    title: '第7条（禁止行為）',
    msg: `利用者の本サービスの利用にあたって、弊社は以下の行為を禁止します。<br/><br/>
    ①弊社に帰属する知的財産権を無断で使用する行為、または侵害する行為。<br/>
    ②弊社及び本サービスから配信される番組を無断で収集、加工、転売等の行為。<br/>
    ③法律・規則・条令等の制定法に反する行為。<br/>
    ④本サービスを通じて与えられた情報（映像・音声・文章・写真・ソフトウェアを含む）を本人の私的使用のための複製を除く複製や第三者へ配布等の行為。`
  },
  {
    title: '第8条（免責事項）',
    msg: `弊社は本サービスの利用に関して利用者が被った損害又は損失などについては、一切の責任を負わないものとします。<br/>
    弊社は利用者が本サービスの利用によって他の利用者又は第三者に対して損害を与えた場合、その一切の責任を負わないものとします。<br/>
    弊社は通信回線やコンピュータ等の障害におけるシステムの中断、遅滞、中止、データの消失、データへの不正アクセスにより生じた損害、又は、その他サービスに関してお客様に生じた損害に対して、一切責任を負わないものとします。`
  },
  {
    title: '第9条（規約の変更）',
    msg: `弊社は利用者の了解を得ることなく本規約を変更することがあります。この場合に、本サービスの利用条件は、変更後の本規約によるものとします。<br/>
    変更後の本規約は、本サービス上に表示した時点より、効力を生じるものとします。`
  }
]
export default protection